import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccountFooter } from '../../../components/account/account-footer/account-footer';
import { AccountHeader } from '../../../components/account/account-header/account-header';

@Component({
  selector: 'app-account-layout-page',
  imports: [RouterModule, AccountHeader, AccountFooter],
  templateUrl: './account-layout-page.html',
  styleUrl: './account-layout-page.scss',
})
export class AccountLayoutPage {}
